"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronJobsName = exports.CronJobStatus = void 0;
var CronJobStatus;
(function (CronJobStatus) {
    CronJobStatus["Pending"] = "pending";
    CronJobStatus["Failed"] = "failed";
    CronJobStatus["Completed"] = "completed";
})(CronJobStatus = exports.CronJobStatus || (exports.CronJobStatus = {}));
var CronJobsName;
(function (CronJobsName) {
    // Add your cron job name here
    CronJobsName["ComputeTimesheets"] = "ComputeTimesheets";
    CronJobsName["EquipmentGeofenceHistory"] = "EquipmentGeofenceHistory";
    CronJobsName["ComputeGeoFenceSummary"] = "ComputeGeoFenceSummary";
    CronJobsName["Violations"] = "Violations";
    CronJobsName["FuelViolations"] = "FuelViolations";
    CronJobsName["ComputeIgnitionSummary"] = "ComputeIgnitionSummary";
    CronJobsName["OperatorHistory"] = "OperatorHistory";
})(CronJobsName = exports.CronJobsName || (exports.CronJobsName = {}));
//# sourceMappingURL=cron_job.js.map